import { render } from "./TabGatepass.vue?vue&type=template&id=6c841636&scoped=true"
import script from "./TabGatepass.vue?vue&type=script&lang=js"
export * from "./TabGatepass.vue?vue&type=script&lang=js"

import "./TabGatepass.vue?vue&type=style&index=0&id=6c841636&scoped=true&lang=css"
import "./TabGatepass.vue?vue&type=style&index=1&id=6c841636&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c841636"]])

export default __exports__